import { Inject, Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { VendorService } from '@galaxy/marketplace-apps/v1';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { PARTNER_ID } from '../../tokens';

@Injectable()
export class ResellersTabRoutingGuard {
  constructor(
    @Inject(PARTNER_ID) private partnerId$: Observable<string>,
    private vendorService: VendorService,
    private router: Router,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canLoad(route: Route): boolean | Observable<boolean> {
    return this.partnerId$.pipe(
      take(1),
      switchMap((partnerId) => this.vendorService.isVendorDistributed(partnerId)),
      map((isDistributed) => {
        if (isDistributed) {
          return true;
        }

        this.router.navigate(['/products'], { queryParamsHandling: 'preserve' });
        return false;
      }),
    );
  }
}
